/**
 * Geolocation operations service.
 * Provides async functions for geolocation-related operations.
 */

interface NavigatorLocation {
  latitude: number;
  longitude: number;
}

/**
 * Get geolocation from browser navigator API.
 */
export function getNavigatorGeolocation(): Promise<NavigatorLocation | null> {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => {
        resolve(null);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  });
}
